import { AxiosError } from 'axios';

/**
 * Create a message useful for the UI from an exception received from the server
 * @param error `unknown` type error.
 * @returns the final error message to display.
 */
export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError && error.response) {
    const errorData = error.response.data as { title?: string; detail?: string };
    const messageParts: string[] = [];

    if (errorData?.title) {
      messageParts.push(errorData.title);
    }
    if (errorData?.detail) {
      messageParts.push(errorData.detail);
    }

    if (messageParts.length > 0) {
      return messageParts.join('\n'); // return the final message
    } else {
      return `Exception: ${error.response.status}`; // return a generic message with a status code
    }
  }

  // Manage another type of error
  if (error instanceof Error) {
    return error.message;
  }

  // Fallback for other cases
  return "An unexpected error occurred.";
};